/**
 * Parent portal UI config — Phase 8.
 * Presentation-only values; business rules come from /v1/config.
 */

/** Max sessions to show on the upcoming-sessions page. */
export const SESSIONS_PAGE_SIZE = 20;

/** Max invoices to show before "Load more". */
export const INVOICES_PAGE_SIZE = 20;

/** Format for displaying session times in the portal. */
export const SESSION_TIME_FORMAT = 'EEE, d MMM yyyy HH:mm';

/** Colour for outstanding balance chip. */
export const BALANCE_OVERDUE_COLOUR = '#ef4444';
export const BALANCE_CREDIT_COLOUR  = '#10b981';

